import "./style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import {
  AbsoluteContainer,
  AppSpan,
  AppText,
  Circle,
  CustomContainer,
  FixedContainer,
  FlexRow,
  GridContainer,
  Icon,
  MenuIcon,
} from "src/style";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import UserContext from "src/provider/state-manager/userProvider";
//import {ReactComponent as Logo} from 'src/assets/img/app-logo-black.svg'
//import {ReactComponent as TransferIcon} from 'src/assets/img/transfer-icon.svg'
//import {ReactComponent as AirtimeIcon} from 'src/assets/img/airtime-icon.svg'
//import {ReactComponent as BillsIcon} from 'src/assets/img/bills-icon.svg'
//import {ReactComponent as CardlessWithdrawalIcon} from 'src/assets/img/cardless-withdrawal-icon.svg'
import TransferIcon from "src/assets/svg/transfer-icon";
import AirtimeIcon from "src/assets/svg/airtime-icon";
import BillsIcon from "src/assets/svg/bills-icon";
import { BsBellFill } from "react-icons/bs";
import { FiMenu } from "react-icons/fi";
import { VscChromeClose } from "react-icons/vsc";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";
import {
  AccountUpgrade,
  Airtime_Data,
  BillTypes,
  CardlessWithdrawal,
  MakeTransfer,
  MyAccount,
  NotificationPop,
  QuickLinks,
} from "src/component";
import utility from "src/utils/utility";
import { useLocation } from "react-router-dom";
import { Features } from "src/model";
import AlertModal from "src/component/AlertModal";
import CbpSendMoney from "src/component/Popup/Cbp/CbpSendMoney";

export const Header = () => {
  const location = useLocation();
  const { visibility, showSideBar, setVisibilityProperty } =
    useContext(VisibilityContext);
  const {
    info: { institutionData ,cbp},
  } = useContext(AppInfoContext);
  const {
    user: {
      userInfo: { profileInfo },
      notifications,
      uploadedProfilePics,
    },
  } = useContext(UserContext);
  const [isQuicklinks, setIsQuicklinks] = useState(false);
  const [isNotifPop, setIsNotifPop] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);
  const [isAirtime_Data, setIsAirtime_Data] = useState(false);
  const [isBillsPayment, setIsBillsPayment] = useState(false);
  const [isCardlessWithdrawal, setIsCardlessWithdrawal] = useState(false);
  const [title, setTitle] = useState("home");
  const screenRef = useRef(false);
  const [appLogo, setAppLogo] = useState("");
  const [view, setView] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [verifyAccount, setVerifyAccount] = useState(false);
  const [uploadedPics, setUploadedPics] = useState(uploadedProfilePics);
  const [sendMoney, setSendMoney] = useState(false)
  const [convertMoney, setConvertMoney]= useState(false)

  const isCbp: boolean = cbp ===true

  console.log("institution", institutionData)

  const useVerifyMe: boolean =
    institutionData?.useVerifyMeForTransactions === true &&
    profileInfo?.isFaceVerified === false;

  useEffect(() => {
    if (institutionData) setAppLogo(institutionData.logo);
  }, [institutionData?.logo]);

  useEffect(() => {
    if (uploadedProfilePics) setUploadedPics(uploadedProfilePics);
  }, [uploadedProfilePics]);

  useEffect(() => {
    setTitle(utility.getPageTitle());

    return () => {};
  }, [location]);

  // useEffect(() => {
  //     screenRef.current = window.matchMedia('(max-width: 1150px)').matches
  // }, [window])

  function handleNotification() {
    if (title === "Home" && !window.matchMedia("(max-width: 1150px)").matches) {
      setVisibilityProperty("isDashboardNotif", !visibility.isDashboardNotif);
      return;
    }
    setIsNotifPop(true);
  }

  return (
    <>
      <MenuIcon
        isSideBar={visibility.isSideBar}
        onClick={() => showSideBar(!visibility.isSideBar)}
      >
        {visibility.isSideBar ? (
          <GridContainer width="auto" sizeUnit="" bgColor="#ffffff">
            <VscChromeClose />
          </GridContainer>
        ) : (
          <FiMenu />
        )}
      </MenuIcon>

      <FixedContainer width="100" sizeUnit="%" zIndex="4" top="0" left="0">
        <GridContainer
          height="9"
          bgColor="#ffffff"
          leftPadding="12.7"
          rightPadding="2.5"
          className="header-container"
        >
          <FlexRow justifyContent="space-between" gap="2">
            {/* <Logo className='icon-component header-logo' /> */}
            <CustomContainer width="15.4" height="4">
              {appLogo ? (
                <Icon src={appLogo} className="app-logo-icon" />
              ) : null}
            </CustomContainer>
            <FlexRow
              width="auto"
              sizeUnit=""
              gap="2.5"
              className="header-action-link"
            >
              {(institutionData.featureIDs?.includes(
                Features.INTER_BANK_TRANSFER
              ) ||
                institutionData.featureIDs?.includes(
                  Features.INTRA_BANK_TRANSFER
                )) && (
                <FlexRow gap="1.5" width="auto" sizeUnit="">
                  <TransferIcon
                    className="icon-component"
                    style={{
                      flexBasis: "auto",
                      flexShrink: "0",
                      flexGrow: "0",
                    }}
                  />
                  <AppText
                    textSize="1.6"
                    fontWeight="600"
                    color="#25282B"
                    cursor="pointer"
                    hoverColor="#0D968F"
                    textWrap="normal"
                    onClick={() => {
                      useVerifyMe
                        ? setIsAlert(true)
                        : isCbp ? setSendMoney(true): setIsTransfer(true);
                    }}
                  >
                    {isCbp ? 'Send Money' : 'Transfer'}
                  </AppText>
                </FlexRow>
              )}
              {institutionData.featureIDs?.includes(Features.AIRTIME_TOPUP) && !isCbp && (
                <FlexRow gap="1.5" width="auto" sizeUnit="">
                  <AirtimeIcon
                    className="icon-component"
                    style={{
                      flexBasis: "auto",
                      flexShrink: "0",
                      flexGrow: "0",
                    }}
                  />
                  <AppText
                    textSize="1.6"
                    fontWeight="600"
                    color="#25282B"
                    cursor="pointer"
                    hoverColor="#0D968F"
                    textWrap="normal"
                    onClick={() => {
                      useVerifyMe
                        ? setIsAlert(true)
                        : setIsAirtime_Data(true);
                    }}
                  >
                    Airtime
                  </AppText>
                </FlexRow>
              )}
              {institutionData.featureIDs?.includes(Features.BILLS_PAYMENT) && (
                <FlexRow gap="1.5" width="auto" sizeUnit="">
                  <BillsIcon
                    className="icon-component"
                    style={{
                      flexBasis: "auto",
                      flexShrink: "0",
                      flexGrow: "0",
                    }}
                  />
                  <AppText
                    textSize="1.6"
                    fontWeight="600"
                    color="#25282B"
                    cursor="pointer"
                    hoverColor="#0D968F"
                    textWrap="normal"
                    onClick={() => {
                      useVerifyMe
                        ? setIsAlert(true)
                        : setIsBillsPayment(true);
                    }}
                  >
                    {isCbp? 'Convert Money':'Bills'}
                  </AppText>
                </FlexRow>
              )}
              {/*<FlexRow gap='1.5' width='auto' sizeUnit=''>*/}
              {/*    <CardlessWithdrawalIcon */}
              {/*        className='icon-component' */}
              {/*        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  */}
              {/*    />*/}
              {/*    <AppText */}
              {/*        textSize='1.6' fontWeight='600' color='#25282B' //#ADADAD*/}
              {/*        cursor='pointer' hoverColor='#0D968F' textWrap='normal'*/}
              {/*        // cursor='pointer' hoverColor='#ADADAD' textWrap='normal'*/}
              {/*        onClick={() => setIsCardlessWithdrawal(true)}*/}
              {/*    >*/}
              {/*        Cardless Withdrawal*/}
              {/*    </AppText>*/}
              {/*</FlexRow>*/}
            </FlexRow>
            <FlexRow
              gap="0.5"
              className="header-quick-links"
              onClick={() => setIsQuicklinks(true)}
            >
              <AppText
                textSize="1.7"
                fontWeight="600"
                color="#25282B"
                cursor="pointer"
                hoverColor="#0D968F"
              >
                Quick links
              </AppText>
              <AppSpan textSize="2" color="#0D968F" cursor="pointer">
                <HiOutlineChevronDoubleRight />
              </AppSpan>
            </FlexRow>
            <FlexRow width="auto" sizeUnit="" gap="5">
              <GridContainer width="auto" sizeUnit="">
                {notifications?.length > 0 && (
                  <AbsoluteContainer top="1" right="0.2">
                    <Circle size="1" bgColor="#FF0000" borderColor="#ffffff" />
                  </AbsoluteContainer>
                )}
                <AppSpan
                  color="#0D968F"
                  textSize="2.5"
                  onClick={handleNotification}
                >
                  <BsBellFill />
                </AppSpan>
              </GridContainer>
              <Circle
                size="4"
                bgColor="#0D968F"
                className="header-profile-pics"
                overflow="hidden"
                onClick={() => setView("my-account")}
              >
                {!profileInfo?.profilePictureUrl && !uploadedPics ? (
                  <AppText
                    textSize="2.5"
                    fontWeight="600"
                    color="#ffffff"
                    cursor="pointer"
                  >
                    {profileInfo?.firstName && profileInfo?.firstName[0]}
                  </AppText>
                ) : (
                  <Icon
                    src={uploadedPics || profileInfo.profilePictureUrl}
                    minWidth="100"
                    noResize
                    style={{ objectFit: "cover" }}
                  />
                )}
              </Circle>
            </FlexRow>
          </FlexRow>
        </GridContainer>
      </FixedContainer>
      {isQuicklinks && (
        <QuickLinks
          close={() => setIsQuicklinks(false)}
          isTransfer={() => setIsTransfer(true)}
          isAirtime_Data={() => setIsAirtime_Data(true)}
          isBillsPayment={() => setIsBillsPayment(true)}
          isCardlessWithdrawal={() => setIsCardlessWithdrawal(true)}
        />
      )}
      {isNotifPop && <NotificationPop close={() => setIsNotifPop(false)} />}
      {isTransfer && <MakeTransfer close={() => setIsTransfer(false)} />}
      {isAirtime_Data && (
        <Airtime_Data close={() => setIsAirtime_Data(false)} />
      )}
      {isBillsPayment && <BillTypes close={() => setIsBillsPayment(false)} />}
        {sendMoney && <CbpSendMoney close={()=>setSendMoney(false)}/>}
      {isCardlessWithdrawal && (
        <CardlessWithdrawal close={() => setIsCardlessWithdrawal(false)} />
      )}
      {view === "my-account" && <MyAccount close={() => setView("")} />}
      {isAlert && (
        <AlertModal
          title={"Verify your Account"}
          body={
            "To ensure secure transactions, please complete the verification process before performing any transaction. This helps us protect your account and maintain a safe platform for everyone"
          }
          close={() => setIsAlert(false)}
          next={() => {
            setIsAlert(false)
            setVerifyAccount(true);
          }}
        />
      )}
      {verifyAccount && (
        <AccountUpgrade close={() => setVerifyAccount(false)} verifyMe={true} />
      )}
    </>
  );
};
